// src/features/subscription/subscriptionThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import subscriptionApi from "../../api/userApi";

/* ============================
   FETCH PLANS (FORCE REFRESH)
============================ */
export const fetchPlans = createAsyncThunk(
  "subscription/fetchPlans",
  async ({ force } = {}, { rejectWithValue }) => {
    try {
      const res = await subscriptionApi.fetchPlansApi({
        headers: {
          "Cache-Control": "no-store",
        },
      });

      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error.message ||
          "Failed to load subscription plans"
      );
    }
  },
  {
    condition: ({ force } = {}, { getState }) => {
      if (force) return true;

      const { subscription } = getState();
      return !subscription?.plans?.length;
    },
  }
);

/* ============================
   FETCH MY SUBSCRIPTION (FORCE)
============================ */
export const fetchMySubscription = createAsyncThunk(
  "subscription/fetchMySubscription",
  async ({ force } = {}, { rejectWithValue }) => {
    try {
      const res = await subscriptionApi.fetchMySubscriptionApi({
        headers: {
          "Cache-Control": "no-store",
        },
      });

      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error.message ||
          "Failed to load your subscription"
      );
    }
  },
  {
    condition: ({ force } = {}, { getState }) => {
      if (force) return true;

      const { subscription } = getState();
      return !subscription?.mySubscription;
    },
  }
);

/* ============================
   PURCHASE SUBSCRIPTION
============================ */
export const purchaseSubscription = createAsyncThunk(
  "subscription/purchaseSubscription",
  async ({ planId, paymentMode }, { rejectWithValue }) => {
    try {
      if (!planId) {
        return rejectWithValue("Plan ID is required");
      }

      const res = await subscriptionApi.purchaseSubscriptionApi({
        planId,
        paymentMode,
      });

      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error.message ||
          "Failed to purchase subscription"
      );
    }
  }
);
